"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DialogSelectOption = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Dialog = _interopRequireDefault(require("../Dialog"));
require("./Styles.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DialogSelectOption = exports.DialogSelectOption = /*#__PURE__*/function (_React$Component) {
  _inherits(DialogSelectOption, _React$Component);
  var _super = _createSuper(DialogSelectOption);
  function DialogSelectOption() {
    var _this;
    _classCallCheck(this, DialogSelectOption);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onSelect", function () {
      _this.props.onSelect(_this.props.option);
    });
    return _this;
  }
  _createClass(DialogSelectOption, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        option = _this$props.option,
        selected = _this$props.selected,
        renderOption = _this$props.renderOption;
      return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: 'dialogselect-option' + (selected ? ' selected' : ''),
        "data-option": option.identifier,
        onClick: this.onSelect
      }, renderOption ? renderOption(option) : option.title);
    }
  }]);
  return DialogSelectOption;
}(_react["default"].Component);
var DialogSelect = exports["default"] = /*#__PURE__*/function (_React$Component2) {
  _inherits(DialogSelect, _React$Component2);
  var _super2 = _createSuper(DialogSelect);
  function DialogSelect(props) {
    var _this2;
    _classCallCheck(this, DialogSelect);
    _this2 = _super2.call(this, props);
    _defineProperty(_assertThisInitialized(_this2), "onClickAway", function (e) {
      var element = e.target;
      do {
        if (element === _this2.control) {
          return;
        }
        element = element.parentElement;
      } while (element);
      _this2.closeDialog();
    });
    _defineProperty(_assertThisInitialized(_this2), "showDialog", function () {
      window.addEventListener('click', _this2.onClickAway, true);
      _this2.setState({
        isOpen: true
      });
      _this2.props.onFocus && _this2.props.onFocus();
    });
    _defineProperty(_assertThisInitialized(_this2), "closeDialog", function () {
      window.removeEventListener('click', _this2.onClickAway, true);
      _this2.setState({
        isOpen: false
      });
    });
    _defineProperty(_assertThisInitialized(_this2), "toggleDialog", function () {
      if (_this2.props.disabled) {
        return;
      }
      _this2.state.isOpen ? _this2.closeDialog() : _this2.showDialog();
      if (_this2.props.onToggle !== undefined) {
        _this2.props.onToggle();
      }
    });
    _defineProperty(_assertThisInitialized(_this2), "onChange", function (option) {
      _this2.closeDialog();
      if (!_this2.isSelected(option)) {
        _this2.props.onChange(option);
      }
    });
    _this2.state = {
      isOpen: false
    };
    return _this2;
  }
  _createClass(DialogSelect, [{
    key: "isSelected",
    value: function isSelected(option) {
      if ((0, _isFunction["default"])(this.props.isSelected)) {
        return this.props.isSelected(option);
      }
      var valueProperty = this.props.valueProperty;
      if (!this.props.value) {
        return false;
      }

      // if there are more values in the selection
      if ((0, _isEqual["default"])(this.props.value)) {
        var _iterator = _createForOfIteratorHelper(this.props.value),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var v = _step.value;
            if (valueProperty) {
              if (v[valueProperty] === option[valueProperty]) {
                return true;
              }
            } else {
              if (v === option) {
                return true;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (valueProperty) {
        return this.props.value[valueProperty] === option[valueProperty];
      } else {
        return this.props.value === option;
      }
    }
  }, {
    key: "renderOption",
    value: function renderOption(option, key) {
      var renderOption = this.props.renderOption;
      return /*#__PURE__*/_react["default"].createElement(DialogSelectOption, {
        option: option,
        key: key,
        onSelect: this.onChange,
        selected: this.isSelected(option),
        renderOption: renderOption
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        label = _this$props2.label,
        options = _this$props2.options,
        value = _this$props2.value,
        renderValue = _this$props2.renderValue,
        renderOption = _this$props2.renderOption,
        showSelected = _this$props2.showSelected,
        renderArrow = _this$props2.renderArrow,
        dialogPositioning = _this$props2.dialogPositioning,
        adjustWidth = _this$props2.adjustWidth,
        relativeTo = _this$props2.relativeTo,
        overlay = _this$props2.overlay,
        className = _this$props2.className,
        Dialog = _this$props2.Dialog;
      var topElement = null;
      if (showSelected) {
        if (value) {
          if (renderValue) {
            topElement = renderValue(value);
          } else {
            topElement = renderOption(value, true);
          }
        } else {
          topElement = /*#__PURE__*/_react["default"].createElement("div", {
            className: "dialogselect-label"
          }, label);
        }
      } else {
        topElement = /*#__PURE__*/_react["default"].createElement("div", {
          className: "dialogselect-label"
        }, label);
      }
      var relativeElement = relativeTo || this.control;
      var show = (0, _isEqual["default"])(options) && options.length > 0 && this.state.isOpen;
      var disabled = this.props.disabled || false;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx["default"])('dialogselect', className, disabled && 'disabled'),
        ref: function ref(el) {
          return _this3.control = el;
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "button",
        onClick: this.toggleDialog
      }, topElement, renderArrow()), /*#__PURE__*/_react["default"].createElement(Dialog, {
        className: 'dialogselect-dialog ' + (adjustWidth ? '' : 'auto-width'),
        show: show,
        relativeTo: relativeElement,
        onClose: this.closeDialog,
        animation: "grow",
        relativePosition: dialogPositioning || DialogSelect.dialogPositioning,
        parent: document.getElementById('configuratorscreen'),
        refValue: options,
        width: adjustWidth ? 'adjust' : false,
        overlay: overlay,
        overlayClassName: "dialogselect-overlay"
      }, (0, _isEqual["default"])(options) && options.map(function (option, key) {
        return _this3.renderOption(option, key);
      })));
    }
  }]);
  return DialogSelect;
}(_react["default"].Component);
_defineProperty(DialogSelect, "dialogPositioning", [['left', 'right'], ['top', 'top']]);
DialogSelect.defaultProps = {
  renderArrow: function renderArrow() {
    return null;
  },
  Dialog: _Dialog["default"]
};